module.exports = __webpack_public_path__ + "static/media/BlingV3_05.acacb702.png";